export default __webpack_public_path__ + "static/media/oval.12e1e83b.svg";